// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProductCardExtraLink.module.scss  */
.ProductCardExtraLink-module-Root_32E {
  display: flex;
  align-items: center;
  margin-top: 14px;
  font-family: var(--control-font-family);
  font-size: var(--product-card-font-size-extra-link);
  font-weight: 600;
  line-height: var(--product-card-line-height-extra-link);
  text-decoration: none;
  color: var(--product-card-color-extra-link); }
  .ProductCardExtraLink-module-Root_32E svg {
    color: var(--product-card-color-extra-link); }

.ProductCardExtraLink-module-Text_48G {
  display: block;
  overflow: hidden;
  margin-right: 8px;
  white-space: nowrap;
  text-overflow: ellipsis; }

.ProductCardExtraLink-module-Icon_2Cn {
  flex-shrink: 0;
  transform: scale(0.6); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/ProductCard/ExtraLink/ProductCardExtraLink.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,mDAAmD;EACnD,gBAAgB;EAChB,uDAAuD;EACvD,qBAAqB;EACrB,2CAA2C,EAAE;EAC7C;IACE,2CAA2C,EAAE;;AAEjD;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB,EAAE;;AAE3B;EACE,cAAc;EACd,qBAAqB,EAAE","sourcesContent":["/*  imported from ProductCardExtraLink.module.scss  */\n.ProductCardExtraLink-module-Root_32E {\n  display: flex;\n  align-items: center;\n  margin-top: 14px;\n  font-family: var(--control-font-family);\n  font-size: var(--product-card-font-size-extra-link);\n  font-weight: 600;\n  line-height: var(--product-card-line-height-extra-link);\n  text-decoration: none;\n  color: var(--product-card-color-extra-link); }\n  .ProductCardExtraLink-module-Root_32E svg {\n    color: var(--product-card-color-extra-link); }\n\n.ProductCardExtraLink-module-Text_48G {\n  display: block;\n  overflow: hidden;\n  margin-right: 8px;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.ProductCardExtraLink-module-Icon_2Cn {\n  flex-shrink: 0;\n  transform: scale(0.6); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
